var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutorFeedbackInActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5831_1074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.7338 9.91344C1.8338 9.32678 1.94714 8.62011 2.08047 7.92678C2.14714 7.58011 2.06047 7.32011 1.80047 7.08011C1.3538 6.67344 0.933803 6.24678 0.50047 5.82678C0.0538029 5.39344 -0.112864 4.88011 0.0804696 4.28678C0.273803 3.70011 0.700469 3.36678 1.3138 3.28011C1.92047 3.19344 2.52047 3.09344 3.1338 3.01344C3.48047 2.97344 3.70714 2.82011 3.8538 2.49344C4.10714 1.93344 4.3938 1.39344 4.66714 0.846775C4.94047 0.300109 5.38714 0.00677542 5.98714 0.000108756C6.60714 -0.00655791 7.06047 0.293442 7.3338 0.853442C7.60714 1.40011 7.8938 1.94011 8.14714 2.50011C8.2938 2.82678 8.52714 2.97344 8.8738 3.01344C9.50047 3.09344 10.1271 3.19344 10.7471 3.29344C11.3338 3.38011 11.7271 3.71344 11.9138 4.26678C12.1071 4.83344 11.9738 5.34678 11.5538 5.76678C11.1005 6.22011 10.6405 6.67344 10.1738 7.10678C9.92714 7.33344 9.8538 7.58011 9.9138 7.90678C10.0338 8.54011 10.1538 9.16678 10.2405 9.80011C10.3605 10.6401 9.84714 11.3534 9.00714 11.4534C8.70714 11.4934 8.3538 11.4068 8.06714 11.2801C7.50047 11.0334 6.9538 10.7201 6.40714 10.4201C6.12047 10.2601 5.86047 10.2668 5.56714 10.4201C4.98714 10.7401 4.40714 11.0601 3.80714 11.3334C2.8338 11.8001 1.7338 11.0934 1.7338 9.91344Z",
    fill: "#C0BAD3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5831_1074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 11.48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorFeedbackInActive);
export default __webpack_public_path__ + "static/media/TutorFeedbackInActive.1b01a9440a52c9f0966c59e7a7c92d09.svg";
export { ForwardRef as ReactComponent };